import { render, staticRenderFns } from "./ReportQuestionModal.vue?vue&type=template&id=6463a5a8"
import script from "./ReportQuestionModal.vue?vue&type=script&lang=js"
export * from "./ReportQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports